<template>
    <div class="echart-box">
        <v-chart :options="option" ref="my" autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar';
import 'zrender/lib/svg/svg'
export default {
    name:"char1",
    components:{
         'v-chart': ECharts
    },
    props:{
        xlist:Array,
        data:{
            type:Object,
            default:()=>{
              return {
                  data1:[],
                  data2:[],
                  data3:[],
                  data4:[]
              }
            }
        }
    },
    data(){
        return {
            vxlist:[],
            vdata:{
                data1:[],
                data2:[],
                data3:[],
                data4:[]
            },
            option:{},
            timer:false
        }
    },
     watch:{
        xlist:{
            handler(){              
              this.dataInit();
              this.init()
            },
            deep:false
        }
    },
    methods:{
         dataInit(){              
            
            this.vdata.data1= this.data.data1.slice(0,18); 
            this.vdata.data2= this.data.data2.slice(0,18); 
            this.vdata.data3= this.data.data3.slice(0,18); 
            this.vdata.data4= this.data.data4.slice(0,18); 
            this.vxlist=this.xlist.slice(0,18);    
         
            this.doit()
        },
        //滚动动画
        doit(){    
            if(this.timer){
                clearTimeout(this.timer)
            }
           this.timer= setTimeout(()=>{             
                this.runData()
            },3000)     
        },
        //滚动展示数据计算
        runData(){                 
            this.data.data1.push(this.data.data1.shift());
            this.data.data2.push(this.data.data2.shift());
             this.data.data3.push(this.data.data2.shift());
              this.data.data4.push(this.data.data2.shift());
            this.xlist.push(this.xlist.shift());      

        },       
        init(){            
           
              this.option={
                grid: {
                    top:'10%',
                    left: '5%',
                    right: '5%',
                    bottom:'10%',
                    containLabel: true
                },
                legend: {
                    bottom:'2%',
                    itemWidth:6,
                    itemHeight:6,
                    textStyle:{
                        color:"#fff"
                    },
                    icon:"rect",
                    data: ['今日PV', '昨日PV','7天前PV','30天前PV']
                },
                tooltip:{
                    formatter: function(params,index) {   
                         
                    　　var result = params[0].name+'</br>'
                    　　params.forEach(function (item) {  
                             
                           
                                result += item.seriesName +":"+ item.data + "</br>"
                         
                    　　})                   
                    　　return result                
                    },
                    textStyle:{
                        fontSize:this.chartFontSize
                    },
                    trigger: "axis",
                    axisPointer: {
                        type: "line",  
                        lineStyle:{
                         color:'#E9FF53'
                        } 
                       
                    }
                },                
                xAxis: {
                    
                     splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'solid',
                            width:1,
                        },
                        minInterval:0
                    },
                    axisLabel: {             
                      color:'#fff'
                    },
                    type: 'category',                              
                    data:this.vxlist,
                },
                yAxis: {
                    axisLabel: {             
                      color:'#fff'
                    },
                     splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'dashed',
                            width:1,
                        },
                        minInterval:0
                    },
                    type: 'value'
                },
                series: [{
                    id:'a1',
                  
                    name:"今日PV",
                    data: this.vdata.data1,
                    type: 'line',
                    itemStyle:{
                        normal:{ 
                            color:"#16D1BB"
                        },                  
                    },
                    barWidth:this.barWidth      
                },
                {
                    id:'a2',
                     name:"昨日PV",
                  
                    data: this.vdata.data2,
                    type: 'line',
                    itemStyle:{
                        normal:{ 
                            color:"#B916CE"
                        },                  
                    },
                    barWidth:this.barWidth    
                },
                {
                    id:'a3',
                    
                     name:"7天前PV",
                    data: this.vdata.data3,
                    type: 'line',
                    itemStyle:{
                        normal:{ 
                            color:"#E9FF53"
                        },                  
                    },
                    barWidth:this.barWidth    
                },
                {
                    id:'a4',
                    
                     name:"30天前PV",
                    data: this.vdata.data4,
                    type: 'line',
                    itemStyle:{
                        normal:{ 
                            color:"#FF8853"
                        },                  
                    },
                    barWidth:this.barWidth    
                },
                
                ]
            }           
              setTimeout(()=>{
                 this.$nextTick(()=>{
                this.$refs.my.dispatchAction({
                    type: 'showTip',         
                    seriesIndex: 0,
                    dataIndex: 9                     
                })
            })
            },500)                   
           
           
        }
    },
    mounted(){
     
    }
}
</script>